import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { buildVersion } from 'src/app/environments/build-version';
import { CoreService } from 'src/app/services/core.service';
import { UserAuthService } from 'src/app/services/user-auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html'
})
export class AppComponent {
  buildVersion = buildVersion;
  title = 'Omni Settings';
  private readonly oidcSecurityService = inject(OidcSecurityService);
  userAuthService = inject(UserAuthService);

  languages = appLanguages;
  public selectedLanguage: any = window.localStorage.getItem('language')
    ? JSON.parse(window.localStorage.getItem('language')!)
    : this.languages[0];

  constructor(private settings: CoreService, private translate: TranslateService) {
    translate.setDefaultLang(this.selectedLanguage.code);
    this.settings.setLanguage(this.selectedLanguage);
  }

  ngOnInit() {
    this.userAuthService.systemId.set(34);
    this.oidcSecurityService.checkAuth().subscribe((result) => {

      // Preload authorized pages after authentication check completes
      // This loads pages in the background without blocking navigation
      if (result.isAuthenticated) {
        this.userAuthService.preloadAuthorizedPages();
      }
    });
  }
}

export const appLanguages = [
  {
    language: 'عربي',
    code: 'ar',
    type: 'ar',
    icon: 'assets/images/flag/icon-flag-es.svg',
    languageDir: 'rtl',
  },
  {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: 'assets/images/flag/icon-flag-en.svg',
    languageDir: 'ltr',
  },
];
